export class StepGuideV1SetupHelp {
  constructor (onboarding) {
    this.onboarding = onboarding;
  }

  id = "guide_v1_setup_help";
  title = "Help";

  template = `
  <div class="onboarding-step" data-for="guide_v1_setup_help">
    
    <div class="onboarding-guide">
    
      <h2 class="onboarding-guide-heading">
        Steps to reset your Temp Stick:
      </h2>
      <ol class="onboarding-guide-instruction">
        <li>Remove only one battery and wait 10 secs.</li>
        <li>Insert that battery back into the sensor 6 times.  On the 6th time, leave the battery in the sensor.</li>
        <li>The light should flash a couple of times and return to a steady blinking blue indicating you are back in setup mode.</li>
      </ol>
      
      <img data-for="v1-pull-batteries" class="onboarding-guide-instruction-image" src="${window.site.home}/../assets/images/setup/temp-stick-v1-help-batteries.png" width="500" height="461" />
      
      <p class="onboarding-guide-instruction">
        Click the button to proceed once the blue light is steady blinking.
      </p>
      
      <div class="onboarding-guide-next">
        <button class="button onboarding-guide-next-btn" data-for="guide_v1_setup_help_next">
          The Light Is Blinking Blue
        </button>
      </div>
      
    </div>
   
  </div>
  `;

  onBack = () => {
    this.onboarding.hideBackButton();
    this.onboarding.goToStep("guide_v1_setup_mode");
  }

  onActivate = () => {
    this.onboarding.showBackButton();
  }

  bindActions = () => {

    this.$nextBtn = $(this.onboarding.container).find('button[data-for="guide_v1_setup_help_next"]');
    this.$nextBtn.on('click', () => {
      this.onboarding.goToConnection();
    });

  }

}
